import { useEffect, useRef, useState } from 'react';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import './PasswordGate.css';

// The email is not a secret — only the password gates access.
// Password is stored in Firebase Auth, never in this file.
const GATE_EMAIL = 'italy2026@hillschool.com';

export default function PasswordGate({ children }) {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setAuthed(!!user);
      setChecking(false);
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (!checking && !authed) {
      inputRef.current?.focus();
    }
  }, [checking, authed]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, GATE_EMAIL, password);
    } catch {
      setError('Incorrect password. Please try again.');
      setPassword('');
      inputRef.current?.focus();
    }
    setLoading(false);
  };

  if (checking) {
    return (
      <div className="gate-shell">
        <div className="gate-spinner" />
      </div>
    );
  }

  if (authed) return children;

  return (
    <div className="gate-shell">
      <div className="gate-card">
        <p className="gate-school">The Hill School</p>
        <div className="gate-flag" aria-hidden="true">
          <span className="gate-flag-green" />
          <span className="gate-flag-white" />
          <span className="gate-flag-red" />
        </div>
        <h1 className="gate-title">Italy Trip 2026</h1>
        <p className="gate-subtitle">Enter the trip password to continue</p>

        <form className="gate-form" onSubmit={handleSubmit} noValidate>
          <input
            ref={inputRef}
            className={`gate-input${error ? ' gate-input-error' : ''}`}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            autoComplete="current-password"
            disabled={loading}
          />
          {error && <p className="gate-error">{error}</p>}
          <button
            className="gate-btn"
            type="submit"
            disabled={loading || !password.trim()}
          >
            {loading ? 'Checking…' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  );
}
